/** @jsxImportSource @emotion/react */
import { divider, dropdownContainer, dropdownSelect } from '../styles/DisplayMethodSection.styles';
import CollapsibleSection from './CollapsibleSection';
import OptionMenu from 'components/lab/lab_1/point_data/option_menu/OptionMenu';

const DisplayMethodSection = ({
    selectedData,
    mode,
    setMode,
    selectedRadioOption,
    setSelectedRadioOption,
    pointVectorLayerVisible,
    setPointVectorLayerVisible,
    mapData,
    selectedSubArray,
    status,
}) => {
    if (!selectedData) return null;

    // 기본 표시 방법 옵션들
    const baseOptions = [
        { value: 'pointMap', label: 'Point' },
        { value: 'hexBinMap', label: 'HexBin' },
        { value: 'clusterMap', label: 'Cluster' },
        { value: 'heatMap', label: 'Heat' },
        { value: 'pointStatisticsMap', label: 'Point Statistics' },
    ];

    // 선택된 데이터에 따른 추가 옵션들
    const getAdditionalOptions = () => {
        if (selectedData.name === '폐업음식점(2020)') {
            return [{ value: 'pointTimeMap', label: 'Point Time' }];
        }
        if (selectedData.name === '폐업음식점(covid)') {
            return [{ value: 'circleTimeMap', label: 'Circle Time' }];
        }
        return [];
    };

    const allOptions = [...baseOptions, ...getAdditionalOptions()];

    const handleModeChange = (event) => {
        setMode(event.target.value);
    };

    return (
        <CollapsibleSection title="표시 방법 및 파라미터" defaultExpanded={true}>
            <div css={dropdownContainer}>
                <select css={dropdownSelect} value={mode} onChange={handleModeChange}>
                    {allOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                <div css={divider}></div>

                <OptionMenu
                    mode={mode}
                    selectedRadioOption={selectedRadioOption}
                    setSelectedRadioOption={setSelectedRadioOption}
                    pointVectorLayerVisible={pointVectorLayerVisible}
                    setPointVectorLayerVisible={setPointVectorLayerVisible}
                    mapData={mapData}
                    selectedSubArray={selectedSubArray}
                    status={status}
                />
            </div>
        </CollapsibleSection>
    );
};

export default DisplayMethodSection;
